import domToImage from 'dom-to-image'
import { isEmpty } from 'lodash/fp'

export function downloadHtmlNodeAsImage(element: Node | null, fileName = 'download') {
  if (element) {
    domToImage.toPng(element).then((dataUrl: string) => {
      const link = document.createElement('a')
      link.download = `${fileName}.png`
      link.href = dataUrl
      link.click()
    })
  }
}

export function extractLocaleFormattedCount(
  data: any,
  field: string,
  localeFormat: (value: number | string) => string
) {
  return !isEmpty(data) && data[0] && field in data[0] ? localeFormat(data[0][field]) : 0
}
